import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaLock, FaEye, FaEyeSlash, FaShieldAlt } from "react-icons/fa";
import { API } from "../../config/api";
import swal from "sweetalert";

export default function ModalPassword({ show, handleClose, targetSlip, onSuccess }) {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) {
      swal({
        title: "Perhatian",
        text: "Silakan masukkan password akun Anda terlebih dahulu.",
        icon: "warning",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await API.post(
        "/api/salary-slips-teacher/verify-password",
        { password },
        {
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.status === 200) {
        setPassword("");
        handleClose();
        if (onSuccess) {
          onSuccess(targetSlip);
        }
      }
    } catch (error) {
      swal({
        title: "Verifikasi Gagal",
        text: error?.response?.data?.message || "Password yang Anda masukkan salah.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    setPassword("");
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleModalClose} centered backdrop="static">
      <Modal.Header closeButton style={{ backgroundColor: "#00487F", color: "white" }}>
        <Modal.Title style={{ fontSize: "16px", fontWeight: "600", display: "flex", alignItems: "center", gap: "8px" }}>
          <FaShieldAlt /> Verifikasi Keamanan Slip Gaji
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body style={{ padding: "24px" }}>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "50%",
                backgroundColor: "#e8f2fa",
                color: "#00487F",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "24px",
                marginBottom: "12px",
              }}
            >
              <FaLock />
            </div>
            <h6 style={{ fontWeight: "bold", color: "#1f2937", marginBottom: "4px" }}>
              Konfirmasi Password
            </h6>
            <p style={{ fontSize: "13px", color: "#6b7280", margin: 0 }}>
              Untuk alasan keamanan dan kerahasiaan data, silakan masukkan password login Anda untuk membuka slip gaji{" "}
              {targetSlip?.nama ? <strong>({targetSlip.nama})</strong> : ""}.
            </p>
          </div>

          <Form.Group className="mb-3">
            <Form.Label style={{ fontSize: "13px", fontWeight: "500", color: "#374151" }}>
              Password Login
            </Form.Label>
            <div style={{ position: "relative" }}>
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Masukkan password Anda..."
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
                style={{
                  paddingRight: "40px",
                  borderRadius: "8px",
                  borderColor: "#3272B3",
                  fontSize: "14px",
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  color: "#6b7280",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#f9fafb", borderTop: "1px solid #e5e7eb" }}>
          <Button variant="secondary" onClick={handleModalClose} disabled={loading} style={{ borderRadius: "6px", fontSize: "13px" }}>
            Batal
          </Button>
          <Button
            type="submit"
            disabled={loading}
            style={{
              backgroundColor: "#00487F",
              borderColor: "#00487F",
              borderRadius: "6px",
              fontSize: "13px",
              fontWeight: "500",
            }}
          >
            {loading ? "Memverifikasi..." : "Buka Slip Gaji"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
